<template>
  <div class="print-alert-item">
    <img
      class="print-alert-item__company-logo"
      :src="logo"
      alt="Logo da transportadora"
    >

    <div class="print-alert-item__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "PrintAlertListItem",

  props: {
    logo: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~commons/stylus/core/_vars'

  .print-alert-item
    display flex
    flex-direction column
    align-items flex-start
    justify-content center
    padding 16px

    @media $md
      flex-direction row
      align-items center
      justify-content flex-start

    &__company-logo
      width 96px
      height auto
      margin-bottom 8px

      @media $md
        width 152px
        margin-bottom 0

    &__content
      max-width 790px
      padding-left 0

      @media $md
        padding-left 19px

      >>> a
        margin-inline 2px
</style>
